module.exports = __webpack_public_path__ + "static/media/n_service-report-tag.637c5b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_service-report-tag.png
// module id = 1823
// module chunks = 0 1